<span class="deltakere e2e-deltakere">
  <moete-deltakere-status [deltakere]="deltakere()"/>

  <div class="deltakere-hovermeny e2e-liste e2e-deltakere-hovermeny">
    @if (aktivBrukerKanGodtaEllerAvslaa()) {
      <div class="godtaAvslaa">
        @if (deltakerinformasjon().aktivBrukerKanGodta) {
          <button mat-stroked-button color="primary" (click)="godtaInnkalling()">{{ "Godta" | translate }}</button>
        }
        @if (deltakerinformasjon().aktivBrukerKanAvslaa) {
          <button mat-stroked-button color="warn" (click)="avslaaInnkalling()">{{ "Avslå" | translate }}</button>
        }
      </div>
    }

    @if (deltakerinformasjon().godtatt.length > 0) {
      <tittel-verdi stil="vertikal--med-linje" tittel="{{'Godtatt' | translate}}" class="e2e-godtatt">
        <verdi>
          @for (deltaker of deltakerinformasjon().godtatt; track deltaker.id) {
            <deltaker-i-liste [deltaker]="deltaker"></deltaker-i-liste>
          }
        </verdi>
      </tittel-verdi>
    }

    @if (deltakerinformasjon().avslaatt.length > 0) {
      <tittel-verdi stil="vertikal--med-linje" tittel="{{'Avslått' | translate}}" class="e2e-avslaatt">
        <verdi>
          @for (deltaker of deltakerinformasjon().avslaatt; track deltaker.id) {
            <deltaker-i-liste [deltaker]="deltaker"></deltaker-i-liste>
          }
        </verdi>
      </tittel-verdi>
    }

    @if (deltakerinformasjon().ikkeSvart.length > 0) {
      <tittel-verdi stil="vertikal--med-linje" tittel="{{'Ikke svart' | translate}}" class="e2e-ikke_besvart">
        <verdi>
          @for (deltaker of deltakerinformasjon().ikkeSvart; track deltaker.id) {
            <deltaker-i-liste [deltaker]="deltaker"></deltaker-i-liste>
          }
        </verdi>
      </tittel-verdi>

      @if (ikkeLaastOgSkriverettighet()) {
        <div class="knapp">
          <button mat-button color="primary" class="e2e-sendpurring" (click)="sendPurring()">{{ "Send påminnelse" | translate }}</button>
        </div>
      }
    }

    @if (deltakerinformasjon().ikkeSendt.length > 0) {
      <tittel-verdi stil="vertikal--med-linje" tittel="{{'Innkalling ikke sendt til' | translate}}" class="e2e-ikke_sendt">
        <verdi>
          @for (deltaker of deltakerinformasjon().ikkeSendt; track deltaker.id) {
            <deltaker-i-liste [deltaker]="deltaker"></deltaker-i-liste>
          }
        </verdi>
      </tittel-verdi>
      @if (ikkeLaastOgSkriverettighet()) {
        <div class="knapp">
          <button mat-button color="primary" class="e2e-sendinnkalling" (click)="sendInnkalling()">{{ "Send innkalling" | translate }}</button>
        </div>
      }
    }

    @if (deltakerinformasjon().eksterne.length > 0) {
      <tittel-verdi stil="vertikal--med-linje" tittel="{{'Eksterne deltakere' | translate}}">
        <verdi>
          @for (deltaker of deltakerinformasjon().eksterne; track deltaker.id) {
            <ekstern-deltaker-i-liste [deltaker]="deltaker"/>
          }
          <tips>{{ "Merk at eksterne deltakere ikke får innkalling eller tilgang til Styreplan³" | translate }}</tips>
        </verdi>
      </tittel-verdi>
    }

    @if (deltakerinformasjon().antallInvitert === 0) {
      <div>
        {{ "Ingen har foreløpig blitt invitert til dette møtet." | translate }}
      </div>
    }

  </div>

</span>

<ng-template #sendPurringTemplate>
  <div class="sendPurring">
    <h2 mat-dialog-title>{{ "Send påminnelse"|translate }}</h2>
    <mat-dialog-content>
      <p>{{ 'Påminnelse sendes til:'|translate }}</p>
      <ul>
        @for (deltaker of deltakerinformasjon().ikkeSvart; track deltaker.id) {
          <li>{{ deltaker.medlem.navn }} - {{ deltaker.medlem.epost }}</li>
        }
      </ul>
    </mat-dialog-content>
    <mat-dialog-actions align="center">
      <button mat-button (click)="avbrytSendPurring()">{{ "Avbryt"|translate }}</button>
      <button mat-raised-button color="primary" (click)="sendPurringIDialog()"
              cdkFocusInitial>{{ "Send påminnelse"|translate }}
      </button>
    </mat-dialog-actions>
  </div>
</ng-template>
